var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav Icons - B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250666",
    d: "M4.22266 11.4075V19.1111C4.22266 19.6634 4.67037 20.1111 5.22266 20.1111H18.4078C18.9601 20.1111 19.4078 19.6634 19.4078 19.1111V11.4075",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 732",
    d: "M2.9259 9C2.9259 9.3891 3.00254 9.77439 3.15145 10.1339C3.30035 10.4934 3.5186 10.82 3.79373 11.0951C4.06887 11.3703 4.39551 11.5885 4.75499 11.7374C5.11447 11.8863 5.49976 11.963 5.88887 11.963C6.27797 11.963 6.66326 11.8863 7.02274 11.7374C7.38223 11.5885 7.70886 11.3703 7.984 11.0951C8.25913 10.82 8.47738 10.4934 8.62629 10.1339C8.72771 9.88903 8.7956 9.63221 8.82859 9.37037",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 733",
    d: "M14.7547 9.37048C14.7469 9.43252 14.7371 9.49428 14.7254 9.55567C14.6877 9.75335 14.6298 9.94716 14.5524 10.134C14.4035 10.4935 14.1852 10.8201 13.9101 11.0952C13.635 11.3704 13.3083 11.5886 12.9489 11.7375C12.5894 11.8864 12.2041 11.9631 11.815 11.9631C11.4259 11.9631 11.0406 11.8864 10.6811 11.7375C10.3216 11.5886 9.99499 11.3704 9.71985 11.0952C9.44471 10.8201 9.22646 10.4935 9.07756 10.134C8.97276 9.88097 8.90375 9.61516 8.87207 9.34424",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 734",
    d: "M14.8302 9.55561C14.8679 9.75329 14.9258 9.9471 15.0032 10.1339C15.1521 10.4934 15.3703 10.82 15.6455 11.0952C15.9206 11.3703 16.2473 11.5886 16.6067 11.7375C16.9662 11.8864 17.3515 11.963 17.7406 11.963C18.1297 11.963 18.515 11.8864 18.8745 11.7375C19.234 11.5886 19.5606 11.3703 19.8357 11.0952C20.1109 10.82 20.3291 10.4934 20.478 10.1339C20.5849 9.87595 20.6545 9.60467 20.6853 9.32823C20.6896 9.29032 20.6931 9.25232 20.6958 9.21423",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250665",
    d: "M18.4467 4H5.22026C4.83648 4 4.48656 4.21964 4.31971 4.56525L2 9.37037H22L19.3222 4.51692C19.1463 4.19802 18.8109 4 18.4467 4Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.3a9a8503d2c00e5073b2d2d48a73e98b.svg";
export { ForwardRef as ReactComponent };